export const getUser= state => state.auth.user
export const getAccessToken= state => state.auth.accessToken
export const getAuth= state => state.auth
export const getFilter = state => state.auth.filter
export const getTheme = state => state.auth.theme